export enum AssetVersionPrefix {
  none,
  draft = "D",
  preliminary = "P",
  contractual = "C",
  archive = "A",
}
